import React, { useContext } from 'react'
import Card from '../ui/card/card'
import { NavigationContext } from '../../contexts/navigation';
import ProductionGraph from '../production/graph';
import ExportGraph from '../importExport/ExportGraph';
import ConsumptionGraph from '../Consumptioin/ConsumptionGraph';
import PriceGraph from '../price/priceGraph';
import { LangContext } from '../../contexts/langContext';

function Home(props) {
    const {setActive} = useContext(NavigationContext);
    const {activeLang,setActiveLang} = useContext(LangContext);

    return (
        <div className="row mr-0 ml-0 " >
            <div className="col-12 px-lg-5 pl-5  py-3" >
                <h1 className="title" >{activeLang==="English"?"Home":"घर"}</h1>
                <hr/>
            </div>
            <div className="col-lg-6 p-3 pl-5" >
                <Card variant="green" title={activeLang==="English"?"Price":"मूल्य"} detailHandler={()=>setActive("Price")} >
                    {/* Put Graph Here */}
                    <PriceGraph/>
                </Card>
            </div>
            <div className="col-lg-6 p-3 pl-5 pl-lg-3 pr-lg-5" >
                <Card variant="orange" title={activeLang==="English"?"Production":"उत्पादन"} detailHandler={()=>setActive("Production")} >
                    {/* Put Graph Here */}
                    <ProductionGraph small={true} />
                </Card>
            </div>
            <div className="col-lg-6 p-3 pl-5" >
                <Card variant="orange" title={activeLang==="English"?"Consumption":"सेवन"} detailHandler={()=>setActive("Consumption")} >
                    <ConsumptionGraph small={true} />
                </Card>
            </div>
            <div className="col-lg-6 p-3 pl-5 pl-lg-3 pr-lg-5" >
                <Card variant="green" title={activeLang==="English"?"Import/ Export":"आयात / निर्यात"} detailHandler={()=>setActive("importExport")} >
                    <ExportGraph/>
                </Card>
            </div>
            
            
        </div>
    )
}


export default Home;

